import { render, staticRenderFns } from "./CustomParallax.vue?vue&type=template&id=3a9d6a94&scoped=true&"
import script from "./CustomParallax.vue?vue&type=script&lang=js&"
export * from "./CustomParallax.vue?vue&type=script&lang=js&"
import style0 from "./CustomParallax.vue?vue&type=style&index=0&id=3a9d6a94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9d6a94",
  null
  
)

export default component.exports